var isArrayLike = require('../type/is-array-like');

var indexOf = Array.prototype.indexOf;

var contains = function contains(arr, value) {
  if (!isArrayLike(arr)) {
    return false;
  }

  return indexOf.call(arr, value) > -1;
};

module.exports = contains;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/array/contains.js
// module id = 29
// module chunks = 0